import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState, LeadStatus, LoginStatus } from "../interfaces/auth.interface";

const initialState: AuthState = {
  loginStatus: "pending",
  leadStatus: null,
  isCommonSsoModalVisible: false,
  ssoRedirectUrl: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoginStatus: (state, action: PayloadAction<{ loginStatus: LoginStatus }>) => {
      state.loginStatus = action.payload.loginStatus;
    },
    setLeadStatus: (state, action: PayloadAction<{ leadStatus: LeadStatus | null }>) => {
      state.leadStatus = action.payload.leadStatus;
    },
    setIsCommonSsoModalVisible: (state, action: PayloadAction<boolean>) => {
      state.isCommonSsoModalVisible = action.payload;
    },
    setSsoRedirectUrl: (state, action: PayloadAction<string | undefined>) => {
      state.ssoRedirectUrl = action.payload;
    },
  },
});

export const { setLoginStatus, setLeadStatus, setIsCommonSsoModalVisible, setSsoRedirectUrl } =
  authSlice.actions;
export default authSlice.reducer;
